import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { endpoints } from "@/api/client";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Table, TBody, TD, TH, THead, TR } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { CenteredLoader, ErrorState, EmptyState } from "@/components/ui/feedback";
import { formatDate } from "@/lib/utils";

export function AuditPage() {
  const [resourceType, setResourceType] = useState("");
  const [resourceId, setResourceId] = useState("");
  const q = useQuery({
    queryKey: ["audit", resourceType, resourceId],
    queryFn: () => endpoints.audit({
      resource_type: resourceType || undefined,
      resource_id: resourceId || undefined,
      limit: 200,
    }),
    refetchInterval: 10_000,
  });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Audit log</h1>
        <p className="text-sm text-muted-foreground">Cronologia immutabile di tutte le azioni</p>
      </div>

      <Card>
        <CardHeader>
          <div className="flex flex-col gap-2 sm:flex-row">
            <Input placeholder="Resource type (operatore, formulario, ...)" value={resourceType} onChange={(e) => setResourceType(e.target.value)} />
            <Input placeholder="Resource ID" value={resourceId} onChange={(e) => setResourceId(e.target.value)} />
          </div>
        </CardHeader>
        <CardContent className="p-0">
          {q.isLoading && <CenteredLoader />}
          {q.error && <ErrorState error={q.error} />}
          {q.data && q.data.items.length === 0 && <EmptyState title="Nessuna azione" />}
          {q.data && q.data.items.length > 0 && (
            <Table>
              <THead><TR><TH>Data</TH><TH>Utente</TH><TH>Azione</TH><TH>Risorsa</TH><TH>HTTP</TH><TH>RENTRI</TH><TH>Correlation</TH></TR></THead>
              <TBody>
                {q.data.items.map((a) => (
                  <TR key={a.id}>
                    <TD className="text-xs whitespace-nowrap">{formatDate(a.created_at)}</TD>
                    <TD className="text-xs">{a.user_email ?? "—"}</TD>
                    <TD className="font-mono text-xs">{a.action}</TD>
                    <TD className="text-xs">
                      {a.resource_type && <Badge variant="outline" className="mr-1">{a.resource_type}</Badge>}
                      <span className="font-mono text-[11px]">{a.resource_id ?? ""}</span>
                    </TD>
                    <TD>
                      <Badge variant={a.response_status && a.response_status < 400 ? "success" : "destructive"}>
                        {a.method} {a.response_status ?? "—"}
                      </Badge>
                    </TD>
                    <TD>
                      {a.rentri_status != null && (
                        <Badge variant={a.rentri_status < 400 ? "success" : "destructive"}>{a.rentri_status}</Badge>
                      )}
                    </TD>
                    <TD className="font-mono text-[11px] text-muted-foreground">{a.correlation_id?.slice(0, 8) ?? "—"}</TD>
                  </TR>
                ))}
              </TBody>
            </Table>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
